<template>
    <div class="list-group my-3" :class="{ 'd-none': isCommentClosed && !showClosedComment }">
        <div class="list-group-item d-flex gap-3 py-3"
            :id="`comment_card_${comment.id}`"
            @click="handleFocusComment"
            :class="{ 'comment-greyed-out': isCommentClosed }"
        >
            <div class="d-flex flex-column align-items-center">
                <img class="rounded-circle flex-shrink-0" :src="comment?.commentor?.profile_photo ?? 'https://ui-avatars.com/api/?name=D&color=F5D77F&background=FFF6EB'" width="32" height="32" />
            <p class="text-md">#{{ comment.number }}</p>
            </div>
            <div class="d-flex gap-2 w-100 justify-content-between text-md">
                <div>
                    <div class="d-flex flex-row align-items-center">
                        <h6 class="mb-0">{{comment?.commentor?.name ?? 'Deleted User' }}</h6>
                        <span class="text-light-emphasis ms-2">{{ comment.diffForHuman.created_at }}</span>
                    </div>
                    <p class="mb-0 opacity-75" v-html="comment.content"></p>
                    <div class="d-flex my-1 w-100 align-items-center" v-if="comment.parent_id == null">
                        <div class="mb-0" data-bs-toggle="collapse"
                            :data-bs-target="`#collapse${comment.id}_replies_${_uid}`" aria-expanded="false"
                            :aria-controls="`collapse${comment.id}_replies`">
                            <svg class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                width="20" height="20">
                                <path
                                    d="M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z" />
                                <path
                                    d="M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-start flex-column">
                    <button v-if="comment.can.close"  @click="closeComment" type="button" class="btn btn-sm">
                        <svg v-if="isCommentClosed" xmlns="http://www.w3.org/2000/svg" fill="#2eb248" height="20" viewBox="0 0 512 512">
                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 512 512">
                            <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/>
                        </svg>
                    </button>
                    <button @click="deleteComment" type="button" class="btn btn-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-danger"
                            width="20" height="20">
                            <path fill-rule="evenodd"
                                d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <template v-if="comment.replies">
            <div class="ps-3 border-start border-dark-subtle ms-2 mt-1 collapse"
                :id="`collapse${comment.id}_replies_${_uid}`">
                <template v-for="response in comment.replies">
                    <div class="list-group my-3" :class="{ 'd-none': isCommentClosed && !showClosedComment }">
                        <div class="list-group-item d-flex gap-3 py-3"
                            :class="{ 'comment-greyed-out': isCommentClosed }">
                            <div class="d-flex flex-column align-items-center">
                            <img
                                class="rounded-circle flex-shrink-0"
                                :src="response.commentor?.profile_photo ?? 'https://ui-avatars.com/api/?name=D&color=F5D77F&background=FFF6EB'"
                                width="32"
                                height="32" />
                            <p>#{{ response.number  }}</p>
                            </div>
                            <div class="d-flex gap-2 w-100 justify-content-between">
                                <div>
                                    <div class="d-flex flex-row align-items-center">
                                        <h6 class="mb-0">{{ response?.commentor?.name ?? 'Deleted User' }}</h6>
                                        <span class="text-light-emphasis ms-2">{{ response?.diffForHuman?.created_at
                                        }}</span>
                                    </div>
                                    <p class="mb-0 opacity-75" v-html="response.content"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="comment.can.reply" class="card rounded my-3"
                    :class="{ 'comment-greyed-out': isCommentClosed, 'd-none': isCommentClosed && !showClosedComment  }">
                    <div class="card-body d-flex gap-3 py-3 flex-column">
                        <span class="text-dark fs-5">Reply</span>
                        <fieldset :disabled="isCommentClosed">
                            <textarea class="form-control form-textarea" name="comment" v-model="form.comment"
                                :id="`comment_reply_${comment.id}`" rows="2"></textarea>
                            <div class="d-flex justify-content-end mt-3">
                                <button class="btn btn-sm btn-secondary" @click="reply()">Comment</button>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
export default {
    props: ['comment', 'markup', 'showClosedComment'],
    emits: ['deleted', 'reply', 'closed'],
    inject: ['notyf'],
    data() {
        return {
            isCommentClosed: true,
            form: {
                comment: null,
                markup_id: this.markup.uuid,
                parent_id: this.comment.id,
                company_id: this.comment.company_id,
            }
        }
    },
    mounted() {
        this.handleCloseComment();
            },
    methods: {
        deleteComment() {
            axios.delete(`${this.comment.urls.delete}`)
                .then(response => {
                        if (response.status == 200) {
                            this.$emit('deleted', this.comment);
                            document.dispatchEvent(new CustomEvent('commentDeleted', {
                            detail: { comment: this.comment },
                        }));

                        this.notyf.success("Comment Deleted")
                    }
                })
                .catch(error => {
                    console.error((error))
                })
        },
        closeComment() {
            axios.post(`${this.comment.urls.close}`)
                .then((e) => {
                    document.dispatchEvent(new CustomEvent('commentClosed', {
                        detail: { comment: e.data.data },
                    }));

                    this.isCommentClosed = !this.isCommentClosed;
                })
                .catch(error => {
                    console.error((error))
                })
        },
        reply() {
            axios.post(this.comment.urls.reply, {
                ...this.form,
            }).then(r => {
                this.form.comment = null;
                this.$emit('reply', r.status)
            })
        },
        handleFocusComment(e) {
            let event = new CustomEvent('commentCard', {
                detail: {
                    comment: this.comment,
                    ele: e,
                }
            });
            document.dispatchEvent(event);
        },
        handleCloseComment() {
            this.isCommentClosed = this.comment.closed_at != null
        }
    },
}
</script>

<style scoped>

.text-md {
    font-size: 12px;
}

.mention {
    padding: 0.1rem 0.3rem;
    box-decoration-break: clone;
    color: #348af3;
}
</style>
